import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function StudentCheckOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.563 3.784a3 3 0 012.874 0l7.953 4.338a1 1 0 010 1.756L19 11.18v2.584a3.041 3.041 0 00-.121.115L17 15.757V12.27l-3.562 1.945a3 3 0 01-2.876 0L7 12.27v3.72l3.849 2.101 2.273 2.274a3 3 0 01-2.56-.15l-4.52-2.466A2 2 0 015 15.993V11.18l-2-1.09V17H1v-6.813a2 2 0 011.042-1.756l8.521-4.647zM5.18 9L12 12.72 18.82 9 12 5.28 5.18 9z",
    fill: "#F0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.707 16.707a1 1 0 00-1.414-1.414L17 18.586l-1.293-1.293a1 1 0 00-1.414 1.414L17 21.414l4.707-4.707z",
    fill: "#F0C"
  }));
}
export default StudentCheckOutlineIcon;